// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1Tnbq","left":"StickyBox_left__BRheQ","right":"StickyBox_right__3jVTO"};